export default "__VITE_ASSET__CqcDfWCE__"